import { Icon, type IconProps } from "./icon";

/** Broadcasts: one send reaching out in rings. */
export function BroadcastsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="10" cy="10" r="1.4" />
      <path d="M6.99 13a4.25 4.25 0 0 1 0-6M13.01 7a4.25 4.25 0 0 1 0 6M4.87 15.13a7.25 7.25 0 0 1 0-10.26M15.13 4.87a7.25 7.25 0 0 1 0 10.26" />
    </Icon>
  );
}
